export default "__VITE_ASSET__CngkN3ZN__"